export class Viewport {
  x: number;
  y: number;
  width: number;
  height: number;

  constructor(x: number, y: number, width: number, height: number) {
    this.x = x;
    this.y = y;
    this.width = width;
    this.height = height;
  }

  copy(o: Viewport) {
    this.x = o.x;
    this.y = o.y;
    this.width = o.width;
    this.height = o.height;
  }

  set(x: number, y: number, width: number, height: number) {
    this.x = x;
    this.y = y;
    this.width = width;
    this.height = height;
  }
}
